<template>
	<v-card>
		<v-toolbar color="accent" class="mb-3" dark>
			<v-toolbar-title>
				<v-icon class="mr-3">person</v-icon>
				{{toolbarTitle}}
			</v-toolbar-title>
			<v-spacer/>
		</v-toolbar>

		<template v-if="loaded">
			<volunteer-profile-view v-if="accessProfileData.systemRole === 'VOLUNTEER'"
				:editable="editable" :limited-edition="limitDepartmentEmployeeEdition"></volunteer-profile-view>
			<bidder-profile-view v-else-if="accessProfileData.systemRole === 'BIDDER'"
				:editable="editable"></bidder-profile-view>
			<sub-bidder-profile-view v-else-if="accessProfileData.systemRole === 'SUB_BIDDER'"
				:editable="editable"></sub-bidder-profile-view>
			<inner-user-profile-view v-else :editable="editable"></inner-user-profile-view>
		</template>
	</v-card>
</template>

<script>
	import VolunteerProfileView from "./volunteer/VolunteerProfileView";
	import BidderProfileView from "./bidder/BidderProfileView";
	import {User} from "@/api/generated/User";
	import InnerUserProfileView from "./inner_user/InnerUserProfileView";
	import SubBidderProfileView from "./sub_bidder/SubBidderProfileView";

	export default {
		name: "ProfileViewTemplate",
		components: {SubBidderProfileView, InnerUserProfileView, BidderProfileView, VolunteerProfileView},

		data () {
			return {
				accessProfileData: {},
				toolbarTitle: "",
				loaded: false,
			};
		},

		methods: {
			refresh () {
				this.loaded = false;
        User.getAccessProfileData(this, this.$route.params.userId, successResponse => {
            this.accessProfileData = successResponse;
            this.loaded = true;
            },
          errorResponse => {
            this.$messagesBus.$emit("error", "Nie udało się załadować danych użytkownika", errorResponse);
          });
			}
		},

		mounted() {
			this.refresh();
		},

		props: {
			editable: {
				default: true,
			},
		},

		watch: {
			'$route.params.userId': function () {
				this.refresh();
			},

			'accessProfileData': function () {
				this.toolbarTitle = this.accessProfileData.selfQuery ? "Mój profil" : this.accessProfileData.fullName;
			}
		},

		computed: {
			limitDepartmentEmployeeEdition () {
				return this.roles.isDepartmentEmployee() && !this.accessProfileData.selfQuery;
			}
		}
	};
</script>

<style scoped>
	.v-icon {
		color: #fff !important;
	}
	
</style>
